<template>
    <v-layout style="box-shadow: 0 0.5mm 2mm rgba(0, 0, 0, .3);height: 100%;overflow: hidden;padding: 0px;margin: 0px;">
        <div id="virtual-page"
             style="position: absolute;top: 0;left:0;width: 156mm;z-index: -1;"></div>
        <v-container
                style="padding: 0px;margin: 0px;width: 400px;flex-shrink: 0;overflow: auto;max-height: 720px;">
            <v-simple-form title="">
                <template v-slot:toolbar>
                    <v-btn text tile small color="rgba(0,0,0,.7)" @click="goBack">
                        <v-icon color="gray">mdi-step-backward</v-icon>
                        返回
                    </v-btn>
                    <v-btn text tile small color="rgba(0,0,0,.7)" @click="onSave">
                        <v-icon color="gray">mdi-content-save</v-icon>
                        保存
                    </v-btn>
                    <!--                    <v-btn :loading="$store.getters.loading['DOC_DOWNLOAD']" text tile small color="rgba(0,0,0,.7)"-->
                    <!--                           @click="onDownload">-->
                    <!--                        <v-icon color="gray">mdi-download</v-icon>-->
                    <!--                        下载-->
                    <!--                    </v-btn>-->
                    <!--                    <v-btn text tile small color="rgba(0,0,0,.7)" @click="onEdit">-->
                    <!--                        <v-icon color="gray">mdi-file-word-box</v-icon>-->
                    <!--                        编辑-->
                    <!--                    </v-btn>-->
                    <v-spacer/>
                </template>
                <template v-slot:content>
                    <v-form-textarea :height="60" :field-width="360" vertical :label-width="70"
                                     v-model="doc.draftOrg.text"
                                     label="发文机关标记"></v-form-textarea>
                    <v-layout class="flex flex-row">
                        <v-form-switch class="flex-shrink-0 flex-grow-0" true-value="justify" :label-width="70"
                                       false-value="" v-model="doc.draftOrg.align" vertical
                                       label="两端对齐"></v-form-switch>
                        <v-form-selector v-model="doc.draftOrg.scale" :label-width="70"
                                         items="40|0.4,55|0.55,50|0.5,60|0.6,66|0.66,70|0.7,80|0.8,90|0.9,无|1"
                                         :field-width="90"
                                         vertical label="缩放"></v-form-selector>
                        <v-form-switch v-model="doc.draftOrg.bold" vertical
                                       label="加粗"></v-form-switch>
                    </v-layout>
                    <v-form-switch v-model="doc.draftOrg.top" vertical
                                   label="发文机关置顶"></v-form-switch>
                    <v-form-selector v-model="doc.draftOrg.fontSize" :label-width="70"
                                     items="初号|42pt,小初|36pt,一号|26pt,小一|24pt,二号|22pt,小二|18pt,三号|16pt,小三|15pt,四号|14pt,小四|12pt,五号|10.5pt,小五|9pt,六号|7.5pt,小六|6.5pt,七号字|5.5pt,八号字|5pt,48|48pt,46|46pt,54|54pt"
                                     :field-width="250"
                                     vertical label="字体大小"></v-form-selector>
                    <v-form-field label="字间距（磅）" v-model="doc.draftOrg.letterSpace" :field-width="250"
                                  vertical :label-width="70">
                    </v-form-field>
                    <v-form-field label="行高（磅）" v-model="doc.draftOrg.lineHeight" :field-width="250"
                                  vertical :label-width="70">
                    </v-form-field>
                    <v-divider class="mb-2 mt-2"/>
                    <!--                    <v-form-field :field-width="360" vertical :label-width="70" v-model="doc.docCode.text"-->
                    <!--                                  label="发文字号"></v-form-field>-->
                    <!--                    <v-form-field :field-width="360" vertical :label-width="70" v-model="doc.draftPeople.text"-->
                    <!--                                  label="签发人"></v-form-field>-->
                    <!--                    <v-layout class="flex flex-row">-->
                    <!--                        <v-form-field :field-width="260" vertical :label-width="70" v-model="doc.toOrg.text"-->
                    <!--                                      label="主送机关"></v-form-field>-->
                    <!--                        <v-form-switch v-model="doc.toOrg.bottom" vertical label="移到版记"></v-form-switch>-->
                    <!--                    </v-layout>-->
                    <v-form-textarea :height="60" :field-width="360" vertical :label-width="70" v-model="doc.title.text"
                                     label="标题"></v-form-textarea>
                    <!--                    <v-form-textarea :height="100" :field-width="360" vertical :label-width="70"-->
                    <!--                                     v-model="doc.content.text"-->
                    <!--                                     label="正文"></v-form-textarea>-->
                    <v-layout class="flex flex-row">
                        <v-form-textarea :height="60" :field-width="260" vertical :label-width="70"
                                         v-model="doc.attachment.text"
                                         label="附件">
                        </v-form-textarea>
                        <v-form-switch :field-width="60" v-model="doc.attachment.sequence" vertical
                                       label="附件序号"></v-form-switch>
                    </v-layout>
                    <!--                    <v-form-field :field-width="360" vertical :label-width="70" v-model="doc.sign.org"-->
                    <!--                                  label="发文机关署名"></v-form-field>-->
                    <!--                    <v-form-field :field-width="360" vertical :label-width="70" v-model="doc.sign.date"-->
                    <!--                                  label="发文日期"></v-form-field>-->

                    <!--                    <v-form-field v-if="doc.ccOrg.enable" :field-width="360" vertical :label-width="70"-->
                    <!--                                  v-model="doc.ccOrg.text"-->
                    <!--                                  label="抄送机关"></v-form-field>-->
                    <!--                    <v-form-field v-if="doc.printOrg.enable" :field-width="360" vertical :label-width="70"-->
                    <!--                                  v-model="doc.printOrg.text"-->
                    <!--                                  label="印发机关"></v-form-field>-->
                    <!--                    <v-form-field v-if="doc.printOrg.enable" :field-width="360" vertical :label-width="70"-->
                    <!--                                  v-model="doc.printOrg.date"-->
                    <!--                                  label="印发日期"></v-form-field>-->
                    <!--                    <v-layout class="flex flex-row">-->
                    <!--                        <v-form-selector vertical clearable items="普通,急件,特急,特提,加急,平急" :label-width="70"-->
                    <!--                                         :field-width="160"-->
                    <!--                                         v-model="doc.urgentLevel"-->
                    <!--                                         label="紧急程度"></v-form-selector>-->
                    <!--                        <v-form-selector vertical clearable items="普通,秘密,机密,绝密" :label-width="70" :field-width="150"-->
                    <!--                                         v-model="doc.secretLevel"-->
                    <!--                                         label="密级"></v-form-selector>-->
                    <!--                    </v-layout>-->
                </template>
            </v-simple-form>
        </v-container>
        <v-container class="ma-0 pa-0" style="padding: 0px;margin: 0px;">
            <v-container class="ma-0 pa-0" v-if="false">
                <v-toolbar dense style="margin:1px auto;">
                    <v-overflow-btn class="form-input__border mr-1" flat solo v-model="currentElement.font" hide-details
                                    dense
                                    style="max-width: 250px;"
                                    :items="fontFamily"></v-overflow-btn>
                    <v-overflow-btn class="form-input__border" flat solo v-model="currentElement.fontSize" hide-details
                                    dense
                                    style="max-width: 200px;"
                                    :items="fontSize"></v-overflow-btn>
                    <v-spacer/>
                    <v-btn-toggle dense group>
                        <v-btn value="1" @click="alignJustify" v-if="currentElement.type=='发文机关'">
                            <v-icon>mdi-format-overline</v-icon>
                            分散对齐
                        </v-btn>
                        <v-btn value="2" @click="textScale" v-if="currentElement.type=='发文机关'">
                            <v-icon>mdi-format-horizontal-align-center</v-icon>
                            缩放
                        </v-btn>
                    </v-btn-toggle>
                </v-toolbar>
            </v-container>
            <v-container class="ma-0 pa-0" style="padding: 0px;margin: 0px;">
                <div class="ma-0 pa-0"
                     style="max-height: 720px;overflow:auto;background-color: #e0e0e0;">
                    <div class="page"
                         style="padding-bottom:25mm;position:relative;width: 210mm;min-height: 225mm;background: white;box-shadow: 0 .5mm 2mm rgba(0, 0, 0, .3);margin: 5mm auto;">
                        <div v-html="html"
                             style="min-height: 225mm;font-family: 仿宋_GB2312;font-size: 16pt;position: relative;margin-left: 26mm;margin-right: 24mm;">

                        </div>
                        <template v-if="$store.getters.loading['DOC_SHORT_HTML']">
                            <div style="position:absolute;left:0;top:0;width: 100%;height: 100%;background-color: black;opacity: 0.2;"></div>
                            <v-progress-circular
                                    style="position: absolute;left: 50%;top:30%;z-index: 999"
                                    :width="7"
                                    :size="50"
                                    color="primary"
                                    indeterminate
                            ></v-progress-circular>
                        </template>
                    </div>
                </div>
            </v-container>
        </v-container>
    </v-layout>
</template>

<script>

    import FontFamily from "./fields/FontFamily";
    import FontSize from "./fields/FontSize";

    export default {
        name: "ProjectDetail.vue",
        data() {
            return {
                html: null,
                doc: {
                    ext: {
                        type: 'normal',
                        dept: null,
                        date: null
                    },
                    draftOrg: {
                        type: "发文机关",
                        text: 'XX文件',
                        font: '方正小标宋简体',
                        fontSize: '48pt',
                        letterSpace: 0,
                        align: null,
                        scale: null,
                        enable: true,
                        bold: false
                    },
                    //签发人
                    draftPeople: {
                        type: "签发人",
                        text: '张三',
                        font: '华文楷体',
                        fontSize: '16pt',
                        align: null,
                        scale: null,
                        enable: false
                    },
                    docCode: {
                        type: "发文字号",
                        text: '京械XXX〔2021〕XX号',
                        font: '仿宋_GB2312',
                        fontSize: '16pt',
                        bottom: false,
                        enable: true
                    },
                    title: {
                        type: "标题",
                        text: 'XXXXXXXX',
                        font: '方正小标宋简体',
                        fontSize: '22pt',
                        enable: true
                    },
                    toOrg: {
                        type: "主送机关",
                        text: '各部门',
                        font: '仿宋_GB2312',
                        fontSize: '16pt',
                        bottom: false,
                        enable: true
                    },
                    ccOrg: {
                        type: "抄送机关",
                        text: 'XXXXXXXXXXX',
                        font: '仿宋_GB2312',
                        fontSize: '16pt',
                        enable: false
                    },
                    urgentLevel: null,
                    secretLevel: null,
                    divider: "红色双线",
                    content: {
                        type: "正文",
                        text: "",
                        font: '仿宋_GB2312',
                        fontSize: '16pt',
                        enable: true
                    },
                    attachment: {
                        type: "附件",
                        text: '',
                        sequence: true,
                        font: '仿宋_GB2312',
                        fontSize: '16pt'
                    },
                    printOrg: {
                        type: "印发机关",
                        text: "北京医疗器械检验研究院",
                        date: '2021年10月23日',
                        font: '仿宋_GB2312',
                        fontSize: '14pt',
                        enable: true
                    },
                    sign: {
                        type: "印发日期",
                        org: 'XXX',
                        date: '2014年10月15日',
                        font: '仿宋_GB2312',
                        fontSize: '14pt',
                        enable: true
                    },
                    page: {
                        enable: true,
                        hideFirstPage: true
                    },
                    seal: {
                        type: "公章",
                        imageId: null,
                        uuid: null,
                        url: null,
                        height: 0,
                        width: 0
                    }
                },
                currentElement: {
                    type: null,
                    name: null,
                    font: null,
                    fontSize: null,
                    enable: null
                },
                docId: null,
                dataItem: {
                    id: null,
                    templateId: null,
                    contentText: null,
                    contentHtml: null,
                    fullHtml: null,
                    docStyle: null,
                    title: null,
                    toOrg: null,
                    ccOrg: null,
                    docNo: null,
                    openAttr: null,
                    docFileName: null,
                    docFileId: null,
                    unopenReason: null,
                    urgent: null,
                    secretLevel: null,
                    secretReason: null
                },
                fontFamily: FontFamily,
                fontSize: FontSize
            }
        },
        created() {
            window.theApp.$emit("APP_DRAWER_TOGGLED");
            this.docId = this.$route.query.id;
            if (this.docId) {
                this.queryDetail(this.docId);
            }
        },
        watch: {
            doc: {
                deep: true,
                handler(val) {
                    this.updateStyle();
                }
            }
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },
            onSave() {
                this.dataItem.docStyle = JSON.stringify(this.doc);
                this.$request
                    .request("DOC_UPDATE_STYLE", this.dataItem)
                    .then((response) => {
                        this.$message.success("更新成功");
                    });
            },
            queryDetail(id) {
                this.$request
                    .request("DOC_DETAIL", {rowid: id})
                    .then(response => {
                        this.dataItem = Object.assign(this.dataItem, response.data);
                        this.doc = Object.assign(this.doc, JSON.parse(response.data.docStyle));
                        this.doc.printOrg.date = new Date().format("yyyy年MM月dd日");
                        this.updateStyle();
                    });
            },
            updateStyle() {
                this.$request
                    .request("DOC_SHORT_HTML", this.doc, {params: {docId: this.docId}})
                    .then(response => {
                        this.html = response.data;
                    });
            },
            selectElement(eleName, event) {
                this.currentElement = this.doc[eleName];
                let ele = document.querySelector("[active]");
                if (ele) {
                    ele.removeAttribute('active');
                    let originClass = ele.getAttribute("class") || '';
                    if (originClass.indexOf("gw-element") == -1) {
                        originClass = originClass + "gw-element";
                        ele.setAttribute('class', originClass);
                    }
                }
                let id = event.target.id;
                let parent = event.target.parentNode;
                while (!id && parent) {
                    id = parent.id;
                    parent = parent.parentNode;
                }
                if (!id) {
                    this.$message.error("找不到父节点");
                    return;
                }
                document.getElementById(id).setAttribute('active', '');
                let originClass = document.getElementById(id).getAttribute("class") || '';
                if (originClass.indexOf("gw-element") != -1) {
                    originClass = originClass.replace("gw-element", "");
                    document.getElementById(id).setAttribute('class', originClass);
                }
            },
            alignJustify() {
                if (this.currentElement) {
                    if (this.currentElement.align == 'justify') {
                        this.currentElement.align = '';
                    } else {
                        this.currentElement.align = 'justify';
                    }
                }
            },
            textScale() {
                if (this.currentElement) {
                    if (this.currentElement.scale == 'scalex(0.66)') {
                        this.currentElement.scale = '';
                    } else {
                        this.currentElement.scale = 'scalex(0.66)';
                    }
                }
            },
            onDownload() {
                // this.doc.originHtml = '<p>你好2021年，中国共产党百年华诞，矢志复兴的中华民族，再一次行进到关键一程的关键节点。</p>';
                // this.doc.originHtml=this.doc.originHtml+"<table border=\"1\"  style=\"border-collapse: collapse;border-color: black;\"><tr><td>11</td><td>12</td></tr></table>";
                // this.doc.originHtml=this.doc.originHtml+"<p>述往思来，向史而新。2021年11月8日上午，北京京西宾馆会议楼一层大会议室内，气氛庄重而热烈，党的十九届六中全会第一次全体会议在这里举行。在全面回顾一年来的工作时，习近平总书记提到，中央政治局在全面推进各项工作的同时重点抓了“三件大事”：隆重庆祝中国共产党成立一百周年、开展党史学习教育、筹备党的十九届六中全会。“三件大事”都指向同一个目的——以史为鉴、开创未来。</p>'"
                // this.html = this.$tool.conert2PageHtml2(this.doc);
                this.dataItem.docStyle = JSON.stringify(this.doc);
                this.dataItem.fullHtml = this.getFullHtml();
                this.$request
                    .request("DOC_UPDATE_STYLE", this.dataItem)
                    .then(() => {
                        this.$request.request('DOC_DOWNLOAD', {docId: this.docId}).then(response => {
                            window.open(response.data, '_blank');
                        })
                    });
            },
            onEdit() {
                window.open("/editor.html?type=fullHtml&id=" + this.docId, '_blank');
            },

            /**
             * 将文本转换为标准公文html格式
             * @param c
             * @returns {string}
             */
            convert(content) {
                return this.$tool.text2Html(content);
            }
        }
    }
</script>
